import { render, staticRenderFns } from "./notification-card.vue?vue&type=template&id=3f7587ac&scoped=true&"
import script from "./notification-card.vue?vue&type=script&lang=js&"
export * from "./notification-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7587ac",
  null
  
)

export default component.exports